import { AdInfo, AdType, SessionInfo } from 'qp-store';
import { LocalStorageKeys } from '../LocalStorageKeys';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { SessionStorageKeys } from '../SessionStorageKeys';
import { SessionService } from '../services/session/session.service';

/**
 * Get session info
 *
 * @param sessionStorage
 */

export const getSessionInfo = (sessionStorage: Storage, session: SessionService): SessionInfo => {
  const startTime = new Date();
  if (sessionStorage.getItem(SessionStorageKeys.APP_STARTUP_TIME)) {
    startTime.setTime(Number(sessionStorage.getItem(SessionStorageKeys.APP_STARTUP_TIME)));
  }
  return {
    sessionDurationSec: new Date().getTime() - startTime.getTime(),
    qpSessionID: session.getSessionID(),
  };
};

export const getContentStartedInit = (localStorage: LocalStorageService): void => {
  localStorage.setItem(LocalStorageKeys.CONTENT_START_TIME, '' + new Date().getTime());
};

/**
 * Gets corresponding ad type for New Relic
 *
 * @param contentTimePosition original param sent by event
 * @returns AdType for NewRelic
 */
export const getAdType = (contentTimePosition: string): AdType | string => {
  switch (contentTimePosition) {
    case 'unknown':
      return AdType.PRE.toLowerCase();
    case 'midroll':
      return AdType.MID.toLowerCase();
    case 'postroll':
      return AdType.POST.toLowerCase();
    default:
      return AdType.PRE.toLowerCase();
  }
};

export const getAdInfo = (event: any, adclickURL: string): AdInfo => {
  return {
    adclickURL,
    adType: getAdType(event.adBreakInfo?.contentTimePosition) || 'NA',
    adDuration: event.durationMs / 1000,
    adskipOffset: event.isSkippable ? event.skipOffsetMs / 1000 : 0, // ms to sec,
  };
};

/**
 * Get the percentage of the content by position
 *
 * @param duration in miliseconds
 * @param position in miliseconds
 * @returns percentage
 */
export const getPercentage = (duration?: number, position?: number): number => {
  return duration && position && duration > 0 && position > 0 ? (position * 100) / duration : 0;
};
